var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 55.106L40 .5 19.095 45.994 80 55.106z",
    fill: "#FF7E3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 .5L0 55.106l40-19.088V.5z",
    fill: "#FFAB56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 36.018L0 55.106h80L40 36.018z",
    fill: "#FF982A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.894L40 73.5l20.905-45.494L0 18.894z",
    fill: "#FFD250"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73.5l40-54.606-40 19.088V73.5z",
    fill: "#FFEA76"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37.982l40-19.088H0l40 19.088z",
    fill: "#FFC25E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.346 45.733L40 18.894l-10.57 22.33 30.916 4.509z",
    fill: "#FF982A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18.894L19.654 45.735 40 36.224v-17.33z",
    fill: "#FF7E3D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40 36.224l-20.346 9.511 40.691-.002L40 36.223z",
    fill: "#FFAB56"
  })));
}

export default __webpack_public_path__ + "./fonts/star.f4195a45d09a517bb6be1b902b2b0113.svg";
export { SvgStar as ReactComponent };